import axios from "axios";
import { ZeaOneBaseUrl, ZeaOneAppId, ZeaOneApiKey } from "../../Constant/Setting";

const ZeaOneInstance = axios.create({
    baseURL: ZeaOneBaseUrl,
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': ZeaOneApiKey,
    }
});

// Set up an Axios request interceptor to add the authorization token
ZeaOneInstance.interceptors.request.use((config) => {
    // Add any additional headers or authentication if needed
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Set up an Axios response interceptor to handle errors
ZeaOneInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error('ZeaOne API Error:', error);
        return Promise.reject(error);
    }
);

export default ZeaOneInstance;
